import React, { useState, useEffect } from "react";
import Modal from "../../utils/components/common/modal";
import { useTranslation } from "react-i18next";
import { formatDate, getTaskFormattedTime } from "../../utils/utils";
import Icons from "../../utils/components/icons";

const ScheduleDetails = ({ scheduleDetails, onClose }) => {
  const { t } = useTranslation("schedules");
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [jobData, setJobData] = useState([]);
  const taskHeadings = ["task", "when", "action"];

  useEffect(() => {
    if (scheduleDetails) {
      let initialJobData = [];
      const modesList = {
        OPERATIONAL: t("changeModesTo.operational"),
        SENSE_ONLY: t("changeModesTo.senseOnly"),
        STANDBY: t("changeModesTo.standBy"),
        RESEARCH: t("changeModesTo.research"),
      };

      const jobList = scheduleDetails.jobList.map((job) => {
        const timeSections = job.jobTime.split(" ");
        let timeWithMinHour;

        if (timeSections.length > 5) {
          timeWithMinHour = timeSections.slice(1).join(" ");
        } else {
          timeWithMinHour = timeSections.join(" ");
        }

        return {
          associatedModesList: getTaskFormattedTime(
            timeWithMinHour,
            scheduleDetails.ScheduleDurationType
          ),
          jobsList: modesList[job.targetMode],
        };
      });

      initialJobData = jobList;

      setJobData(initialJobData);
    }
  }, [scheduleDetails, t]);

  return (
    <div className="schd-info-device-modal-container">
      <Modal
        isOpen={isModalOpen}
        isCloseButton={false}
        className="schd-info-device-modal"
        idName="schd-info-device-modal"
      >
        <div>
          {scheduleDetails && (
            <>
              {/* Header Starts */}
              <div className="info-header">
                <div className="leftSection">
                  <span id="infoIcon">{Icons.infoIcon}</span>
                  <p className="heading" id="temp-info-heading">
                    {`${t("templateInfo")} - ${scheduleDetails?.scheduleTemplateName}`}
                  </p>
                </div>
                <span
                  id="closeIcon"
                  onClick={() => {
                    setIsModalOpen(false);
                    onClose();
                  }}
                >
                  {Icons.closeColorFilledIcon}
                </span>
              </div>
              {/* Header Ends */}

              {/* Body Starts */}
              <div className="info-body">
                <div className="descSection" id="descSection">
                  <span className="heading heading-h3" id="desc-title">{t("scheduleDesc")}</span>
                  <span className="dott text-h3">:</span>
                  <span className="desc"  id="desc-value">
                    <span className="value text-h1">
                      {scheduleDetails?.scheduleTemplateDescription
                        ? scheduleDetails.scheduleTemplateDescription
                        : "-"}
                    </span>
                  </span>
                </div>

                <div className="jobDetailsSection">
                  <span className="heading" id="task-titles">{t("scheduleTasks")}</span>
                  <div className="job-body" id="task-body">
                    <table className="table" id="temp-task-table">
                      <thead>
                        <tr>
                          {taskHeadings.map((heading) => (
                            <td key={heading} className={heading }>
                              <label id={`${heading}Label`} className="text-h3">
                                {t(`taskHeadings.${heading}`)}
                              </label>
                            </td>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="jobsTableBody">
                        {jobData.map((job, i) => (
                          <tr key={job?.jobTime}>
                            <td name="jobId">
                              <span id={`jobId_${i + 1}`} className="jobId heading-h4">{`${
                                i + 1
                              }`}</span>
                            </td>
                            <td name="jobModesList">
                              <span
                                id={`jobModesList${i + 1}`}
                                className="jobModesList heading-h4"
                              >
                                {job?.associatedModesList}
                              </span>
                            </td>
                            <td name="jobsList">
                              <span
                                id={`jobsList${i + 1}`}
                                className="jobsList heading-h4"
                              >
                                {job?.jobsList}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* Body Ends */}

              {/* Footer Starts */}
              <div className="info-footer">
                <div className="footerDetails">

                  <div className="createdDetails">
                  <span className="label text-h4" id="createdOn">
                    {t("createdOn")}
                    &nbsp;
                  </span>
                  <span className="value text-h4" id="createdDateTime">
                    {formatDate(scheduleDetails?.updatedDateTime, false)}
                  </span>
                  </div>
                  <div className="createdDetails">
                  <span className="label text-h4" id="createdBy">
                    {t("createdBy")}
                    &nbsp;
                  </span>
                  <span className="value text-h4" id="createdByUserEmail">
                    {scheduleDetails?.updatedByUserEmail ? scheduleDetails.updatedByUserEmail : scheduleDetails?.createdByUserEmail}
                  </span>
                  </div>
                </div>
              </div>
              {/* Footer Ends */}
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ScheduleDetails;
